import { useTranslation } from '@lyearn/i18n';
import { AlertDialog } from '@lyearn/molecules';
interface ChangeDepartmentDialogProps {
  onPrimaryAction: VoidFunction;
  onRevert: VoidFunction;
}

const ChangeDepartmentDialog: React.FC<ChangeDepartmentDialogProps> = ({
  onPrimaryAction,
  onRevert,
}) => {
  const { t } = useTranslation();

  return (
    <AlertDialog
      header={{
        title: t('Admin:InviteStaff.ChangingDepartment'),
        description: t('Admin:InviteStaff.ChangingDepartmentDescription'),
      }}
      primaryAction={{ label: t('Common:Actions.ChangeAnyway'), onClick: onPrimaryAction }}
      secondaryAction={{ label: t('Common:Actions.Revert') }}
      onClose={onRevert}
    />
  );
};

export default ChangeDepartmentDialog;
